import { render } from "./leavelist-svg.vue?vue&type=template&id=090f86a2"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__